import { Button } from '@mui/material';
import RESOURCES from '~/resources';
import useStyles from './useStyles';
import dynamic from 'next/dynamic';
import { CSSProperties } from 'react';

const ColoredCarWishlistIcon = dynamic(
  () => import('~/assets/icons/jsx/coloredHeartIcon'),
  { ssr: false },
);
const CarWishlistIcon = dynamic(
  () => import('~/assets/icons/jsx/saveHeartIcon'),
  { ssr: false },
);

interface WishlistButtonProps {
  onClick: () => void;
  isClicked?: boolean;
  carTitle?: string;
  customStyles?: CSSProperties;
}

const WishlistButton = ({
  onClick,
  isClicked = false,
  carTitle,
  customStyles,
}: WishlistButtonProps) => {
  const classes = useStyles();

  return (
    <Button
      aria-label={`${RESOURCES.ADD_TO_FAV} ${carTitle || ''}`}
      sx={{ ...classes.root, ...customStyles }}
      onClick={onClick}
      type="button"
      aria-pressed={isClicked}
      disableRipple
    >
      {isClicked ? <ColoredCarWishlistIcon /> : <CarWishlistIcon />}
    </Button>
  );
};

export default WishlistButton;
